import request from '@/utils/request';

export function getProblemAndOrder(query) {
  return request({
    url: '/api/system/shopProblem/getProblemAndOrder',
    method: 'post',
    data: query
  });
}

export function getShopProblemPage(query) {
  return request({
    url: '/api/system/shopProblem/queryShopProblemPage',
    method: 'post',
    data: query
  });
}

export function getShopProblemList(query) {
  return request({
    url: '/api/system/shopProblem/queryShopProblemList',
    method: 'post',
    data: query
  });
}

export function updateShopProblem(form) {
  return request({
    url: '/api/system/shopProblem/updateShopProblem',
    method: 'post',
    data: form
  });
}

export function saveShopProblem(form) {
  return request({
    url: '/api/system/shopProblem/saveShopProblem',
    method: 'post',
    data: form
  });
}

export function queryOrderLogistics(form) {
  return request({
    url: '/api/system/shopProblem/queryOrderLogistics',
    method: 'post',
    data: form
  });
}

export function deleteShopProblem(id) {
  return request({
    url: '/api/system/shopProblem/deleteShopProblem',
    method: 'post',
    data: {'id': id}
  });
}

export function getShopProblemById(id) {
  return request({
    url: '/api/system/shopProblem/getShopProblem',
    method: 'post',
    data: {'id': id}
  });
}

export function getProblemDetail(id) {
  return request({
    url: '/api/system/shopProblem/getProblemDetail',
    method: 'post',
    data: {'id': id}
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/shopProblem.js